import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useWizard } from 'react-use-wizard'
import { Button } from 'web/src/app/root/components/common'
import { useSelector } from 'react-redux'

/* eslint-disable */
const useStyles = makeStyles(theme => ({
    wrapper: {
        paddingRight: 20,
        overflowX: 'auto',
        overflowY: 'auto',
        maxHeight: '100%',
        maxWidth: '100%'
    },
    link: {
        color: theme.textPrimary,
        cursor: 'pointer',
        fontWeight: 'bold'
    },
    heading: {
        fontFamily: theme.typography.fontFamily,
        fontWeight: 'bold',
        fontSize: 30,
        textAlign: 'center',
        paddingBottom: 70
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '20px',
        '& > *': {
            marginRight: '10px'
        }
    }
}))

export default function EnTerms({ acceptTs }) {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)

    const { previousStep, nextStep } = useWizard()

    return (
        <React.Fragment>
            <div className={classes.wrapper}>
                <h1 className={classes.heading}>Privacy Policy</h1>
                <h2>1. An overview of data protection</h2>
                <h3>General information</h3>{' '}
                <p>
                    The following information will provide you with an easy to
                    navigate overview of what will happen with your personal
                    data when you visit this website. The term “personal data”
                    comprises all data that can be used to personally identify
                    you. For detailed information about the subject matter of
                    data protection, please consult our Data Protection
                    Declaration, which we have included beneath this copy.
                </p>
                <h3>Data recording on this website</h3>{' '}
                <h4>
                    Who is the responsible party for the recording of data on
                    this website (i.e. the “controller”)?
                </h4>{' '}
                <p>
                    The data on this website is processed by the operator of the
                    website, whose contact information is available under
                    section “Information about the responsible party (referred
                    to as the “controller” in the GDPR)” in this Privacy Policy.
                </p>{' '}
                <h4>How do we record your data?</h4>{' '}
                <p>
                    We collect your data as a result of your sharing of your
                    data with us. This may, for instance be information you
                    enter into our contact form.
                </p>{' '}
                <p>
                    Other data shall be recorded by our IT systems automatically
                    or after you consent to its recording during your website
                    visit. This data comprises primarily technical information
                    (e.g. web browser, operating system, or time the site was
                    accessed). This information is recorded automatically when
                    you access this website.
                </p>{' '}
                <h4>What are the purposes we use your data for?</h4>{' '}
                <p>
                    A portion of the information is generated to guarantee the
                    error free provision of the website. Other data may be used
                    to analyze your user patterns.
                </p>{' '}
                <h4>
                    What rights do you have as far as your information is
                    concerned?
                </h4>{' '}
                <p>
                    You have the right to receive information about the source,
                    recipients, and purposes of your archived personal data at
                    any time without having to pay a fee for such disclosures.
                    You also have the right to demand that your data are
                    rectified or eradicated. If you have consented to data
                    processing, you have the option to revoke this consent at
                    any time, which shall affect all future data processing.
                    Moreover, you have the right to demand that the processing
                    of your data be restricted under certain circumstances.
                    Furthermore, you have the right to log a complaint with the
                    competent supervising agency.
                </p>{' '}
                <p>
                    Please do not hesitate to contact us at any time if you have
                    questions about this or any other data protection related
                    issues.
                </p>
                <h2>2. General information and mandatory information</h2>
                <h3>Data protection</h3>{' '}
                <p>
                    The operators of this website and its pages take the
                    protection of your personal data very seriously. Hence, we
                    handle your personal data as confidential information and in
                    compliance with the statutory data protection regulations
                    and this Data Protection Declaration.
                </p>{' '}
                <p>
                    Whenever you use this website, a variety of personal
                    information will be collected. Personal data comprises data
                    that can be used to personally identify you. This Data
                    Protection Declaration explains which data we collect as
                    well as the purposes we use this data for. It also explains
                    how, and for which purpose the information is collected.
                </p>{' '}
                <p>
                    We herewith advise you that the transmission of data via the
                    Internet (i.e. through e-mail communications) may be prone
                    to security gaps. It is not possible to completely protect
                    data against third-party access.
                </p>
                <h3>
                    Information about the responsible party (referred to as the
                    “controller” in the GDPR)
                </h3>{' '}
                <p>The data processing controller on this website is:</p>{' '}
                <p>
                    traplinked GmbH
                    <br />
                    Zollhof 7<br />
                    90443 Nürnberg
                </p>
                <p>
                    Phone: +49 911 47712850
                    <br />
                    E-mail: kontakt@traplinked.com
                </p>
                <p>
                    The controller is the natural person or legal entity that
                    single-handedly or jointly with others makes decisions as to
                    the purposes of and resources for the processing of personal
                    data (e.g. names, e-mail addresses, etc.).
                </p>
                <h3>Storage duration</h3>{' '}
                <p>
                    Unless a more specific storage period has been specified in
                    this privacy policy, your personal data will remain with us
                    until the purpose for which it was collected no longer
                    applies. If you assert a justified request for deletion or
                    revoke your consent to data processing, your data will be
                    deleted, unless we have other legally permissible reasons
                    for storing your personal data (e.g. tax or commercial law
                    retention periods); in the latter case, the deletion will
                    take place after these reasons cease to apply.
                </p>
                <h3>Information on data transfer to the USA</h3>{' '}
                <p>
                    Our website uses, in particular, tools from companies based
                    in the USA. When these tools are active, your personal
                    information may be transferred to the US servers of these
                    companies. We must point out that the USA is not a safe
                    third country within the meaning of EU data protection law.
                    US companies are required to release personal data to
                    security authorities without you as the data subject being
                    able to take legal action against this. The possibility
                    cannot therefore be excluded that US authorities (e.g.
                    secret services) may process, evaluate, and permanently
                    store your data on US servers for monitoring purposes.  We
                    have no influence over these processing activities.
                </p>
                <h3>Revocation of your consent to the processing of data</h3>{' '}
                <p>
                    A wide range of data processing transactions are possible
                    only subject to your express consent. You can also revoke at
                    any time any consent you have already given us. This shall
                    be without prejudice to the lawfulness of any data
                    collection that occurred prior to your revocation.
                </p>
                <h3>
                    Right to object to the collection of data in special cases;
                    right to object to direct advertising (Art. 21 GDPR)
                </h3>{' '}
                <p>
                    IN THE EVENT THAT DATA ARE PROCESSED ON THE BASIS OF ART. 6
                    SECT. 1 LIT. E OR F GDPR, YOU HAVE THE RIGHT TO AT ANY TIME
                    OBJECT TO THE PROCESSING OF YOUR PERSONAL DATA BASED ON
                    GROUNDS ARISING FROM YOUR UNIQUE SITUATION. THIS ALSO
                    APPLIES TO ANY PROFILING BASED ON THESE PROVISIONS. TO
                    DETERMINE THE LEGAL BASIS, ON WHICH ANY PROCESSING OF DATA
                    IS BASED, PLEASE CONSULT THIS DATA PROTECTION DECLARATION.
                    IF YOU LOG AN OBJECTION, WE WILL NO LONGER PROCESS YOUR
                    AFFECTED PERSONAL DATA, UNLESS WE ARE IN A POSITION TO
                    PRESENT COMPELLING PROTECTION WORTHY GROUNDS FOR THE
                    PROCESSING OF YOUR DATA, THAT OUTWEIGH YOUR INTERESTS,
                    RIGHTS AND FREEDOMS OR IF THE PURPOSE OF THE PROCESSING IS
                    THE CLAIMING, EXERCISING OR DEFENCE OF LEGAL ENTITLEMENTS
                    (OBJECTION PURSUANT TO ART. 21 SECT. 1 GDPR).
                </p>{' '}
                <p>
                    IF YOUR PERSONAL DATA IS BEING PROCESSED IN ORDER TO ENGAGE
                    IN DIRECT ADVERTISING, YOU HAVE THE RIGHT TO AT ANY TIME
                    OBJECT TO THE PROCESSING OF YOUR AFFECTED PERSONAL DATA FOR
                    THE PURPOSES OF SUCH ADVERTISING. THIS ALSO APPLIES TO
                    PROFILING TO THE EXTENT THAT IT IS AFFILIATED WITH SUCH
                    DIRECT ADVERTISING. IF YOU OBJECT, YOUR PERSONAL DATA WILL
                    SUBSEQUENTLY NO LONGER BE USED FOR DIRECT ADVERTISING
                    PURPOSES (OBJECTION PURSUANT TO ART. 21 SECT. 2 GDPR).
                </p>
                <h3>
                    Right to log a complaint with the competent supervisory
                    agency
                </h3>{' '}
                <p>
                    In the event of violations of the GDPR, data subjects are
                    entitled to log a complaint with a supervisory agency, in
                    particular in the member state where they usually maintain
                    their domicile, place of work or at the place where the
                    alleged violation occurred. The right to log a complaint is
                    in effect regardless of any other administrative or court
                    proceedings available as legal recourses.
                </p>
                <h3>Right to data portability</h3>{' '}
                <p>
                    You have the right to demand that we hand over any data we
                    automatically process on the basis of your consent or in
                    order to fulfil a contract be handed over to you or a third
                    party in a commonly used, machine readable format. If you
                    should demand the direct transfer of the data to another
                    controller, this will be done only if it is technically
                    feasible.
                </p>
                <h3>SSL and/or TLS encryption</h3>{' '}
                <p>
                    For security reasons and to protect the transmission of
                    confidential content, such as purchase orders or inquiries
                    you submit to us as the website operator, this website uses
                    either an SSL or a TLS encryption program. You can recognize
                    an encrypted connection by checking whether the address line
                    of the browser switches from “http://” to “https://” and
                    also by the appearance of the lock icon in the browser line.
                </p>{' '}
                <p>
                    If the SSL or TLS encryption is activated, data you transmit
                    to us cannot be read by third parties.
                </p>
                <h3>
                    Information about, rectification and eradication of data
                </h3>{' '}
                <p>
                    Within the scope of the applicable statutory provisions, you
                    have the right to at any time demand information about your
                    archived personal data, their source and recipients as well
                    as the purpose of the processing of your data. You may also
                    have a right to have your data rectified or eradicated. If
                    you have questions about this subject matter or any other
                    questions about personal data, please do not hesitate to
                    contact us at any time.
                </p>
                <h3>Right to demand processing restrictions</h3>{' '}
                <p>
                    You have the right to demand the imposition of restrictions
                    as far as the processing of your personal data is concerned.
                    To do so, you may contact us at any time. The right to
                    demand restriction of processing applies in the following
                    cases:
                </p>{' '}
                <ul>
                    {' '}
                    <li>
                        In the event that you should dispute the correctness of
                        your data archived by us, we will usually need some time
                        to verify this claim. During the time that this
                        investigation is ongoing, you have the right to demand
                        that we restrict the processing of your personal data.
                    </li>{' '}
                    <li>
                        If the processing of your personal data was/is conducted
                        in an unlawful manner, you have the option to demand the
                        restriction of the processing of your data in lieu of
                        demanding the eradication of this data.
                    </li>{' '}
                    <li>
                        If we do not need your personal data any longer and you
                        need it to exercise, defend or claim legal entitlements,
                        you have the right to demand the restriction of the
                        processing of your personal data instead of its
                        eradication.
                    </li>{' '}
                    <li>
                        If you have raised an objection pursuant to Art. 21
                        Sect. 1 GDPR, your rights and our rights will have to be
                        weighed against each other. As long as it has not been
                        determined whose interests prevail, you have the right
                        to demand a restriction of the processing of your
                        personal data.
                    </li>{' '}
                </ul>{' '}
                <p>
                    If you have restricted the processing of your personal data,
                    these data – with the exception of their archiving – may be
                    processed only subject to your consent or to claim, exercise
                    or defend legal entitlements or to protect the rights of
                    other natural persons or legal entities or for important
                    public interest reasons cited by the European Union or a
                    member state of the EU.
                </p>
                <h2>3. Recording of data on this website</h2>
                <h3>Cookies</h3>{' '}
                <p>
                    Our websites and pages use what the industry refers to as
                    “cookies.” Cookies are small text files that do not cause
                    any damage to your device. They are either stored
                    temporarily for the duration of a session (session cookies)
                    or they are permanently archived on your device (permanent
                    cookies). Session cookies are automatically deleted once you
                    terminate your visit. Permanent cookies remain archived on
                    your device until you actively delete them, or they are
                    automatically eradicated by your web browser.
                </p>{' '}
                <p>
                    In some cases, it is possible that third-party cookies are
                    stored on your device once you enter our site (third-party
                    cookies). These cookies enable you or us to take advantage
                    of certain services offered by the third party (e.g. cookies
                    for the processing of payment services).
                </p>{' '}
                <p>
                    Cookies have a variety of functions. Many cookies are
                    technically essential since certain website functions would
                    not work in the absence of the cookies (e.g. the shopping
                    cart function or the display of videos). The purpose of
                    other cookies may be the analysis of user patterns or the
                    display of promotional messages.
                </p>{' '}
                <p>
                    Cookies, which are required for the performance of
                    electronic communication transactions (required cookies) or
                    for the provision of certain functions you want to use
                    (functional cookies, e.g. for the shopping cart function) or
                    those that are necessary for the optimization of the website
                    (e.g. cookies that provide measurable insights into the web
                    audience), shall be stored on the basis of Art. 6 Sect. 1
                    lit. f GDPR, unless a different legal basis is cited. The
                    operator of the website has a legitimate interest in the
                    storage of cookies to ensure the technically error free and
                    optimized provision of the operator’s services. If your
                    consent to the storage of the cookies has been requested,
                    the respective cookies are stored exclusively on the basis
                    of the consent obtained (Art. 6 Sect. 1 lit. a GDPR); this
                    consent may be revoked at any time.
                </p>{' '}
                <p>
                    You have the option to set up your browser in such a manner
                    that you will be notified any time cookies are placed and to
                    permit the acceptance of cookies only in specific cases. You
                    may also exclude the acceptance of cookies in certain cases
                    or in general or activate the delete function for the
                    automatic eradication of cookies when the browser closes. If
                    cookies are deactivated, the functions of this website may
                    be limited.
                </p>{' '}
                <p>
                    In the event that third-party cookies are used or if cookies
                    are used for analytical purposes, we will separately notify
                    you in conjunction with this Data Protection Policy and, if
                    applicable, ask for your consent.
                </p>
                <h3>Server log files</h3>{' '}
                <p>
                    The provider of this website and its pages automatically
                    collects and stores information in so-called server log
                    files, which your browser communicates to us automatically.
                    The information comprises:
                </p>{' '}
                <ul>
                    {' '}
                    <li>The type and version of browser used</li>{' '}
                    <li>The used operating system</li> <li>Referrer URL</li>{' '}
                    <li>The hostname of the accessing computer</li>{' '}
                    <li>The time of the server inquiry</li>{' '}
                    <li>The IP address</li>{' '}
                </ul>{' '}
                <p>This data is not merged with other data sources.</p>{' '}
                <p>
                    This data is recorded on the basis of Art. 6 Sect. 1 lit. f
                    GDPR. The operator of the website has a legitimate interest
                    in the technically error free depiction and the optimization
                    of the operator’s website. In order to achieve this, server
                    log files must be recorded.
                </p>
                <h3>Contact form</h3>{' '}
                <p>
                    If you submit inquiries to us via our contact form, the
                    information provided in the contact form as well as any
                    contact information provided therein will be stored by us in
                    order to handle your inquiry and in the event that we have
                    further questions. We will not share this information
                    without your consent.
                </p>{' '}
                <p>
                    The processing of these data is based on Art. 6 para. 1 lit.
                    b GDPR, if your request is related to the execution of a
                    contract or if it is necessary to carry out pre-contractual
                    measures. In all other cases the processing is based on our
                    legitimate interest in the effective processing of the
                    requests addressed to us (Art. 6 Para. 1 lit. f GDPR) or on
                    your agreement (Art. 6 Para. 1 lit. a GDPR) if this has been
                    requested.
                </p>{' '}
                <p>
                    The information you have entered into the contact form shall
                    remain with us until you ask us to eradicate the data,
                    revoke your consent to the archiving of data or if the
                    purpose for which the information is being archived no
                    longer exists (e.g. after we have concluded our response to
                    your inquiry). This shall be without prejudice to any
                    mandatory legal provisions – in particular retention
                    periods.
                </p>
                <h3>Request by e-mail, telephone, or fax</h3>{' '}
                <p>
                    If you contact us by e-mail, telephone or fax, your request,
                    including all resulting personal data (name, request) will
                    be stored and processed by us for the purpose of processing
                    your request. We do not pass these data on without your
                    consent.
                </p>{' '}
                <p>
                    These data are processed on the basis of Art. 6 Sect. 1 lit.
                    b GDPR if your inquiry is related to the fulfillment of a
                    contract or is required for the performance of
                    pre-contractual measures. In all other cases, the data are
                    processed on the basis of our legitimate interest in the
                    effective handling of inquiries submitted to us (Art. 6
                    Sect. 1 lit. f GDPR) or on the basis of your consent (Art. 6
                    Sect. 1 lit. a GDPR) if it has been obtained.
                </p>{' '}
                <p>
                    The data sent by you to us via contact requests remain with
                    us until you request us to delete, revoke your consent to
                    the storage or the purpose for the data storage lapses (e.g.
                    after completion of your request). Mandatory statutory
                    provisions - in particular statutory retention periods -
                    remain unaffected.
                </p>
                <h3>Registration on this website</h3>{' '}
                <p>
                    You have the option to register on this website to be able
                    to use additional website functions. We shall use the data
                    you enter only for the purpose of using the respective offer
                    or service you have registered for. The required information
                    we request at the time of registration must be entered in
                    full. Otherwise we shall reject the registration.
                </p>{' '}
                <p>
                    To notify you of any important changes to the scope of our
                    portfolio or in the event of technical modifications, we
                    shall use the e-mail address provided during the
                    registration process.
                </p>{' '}
                <p>
                    We shall process the data entered during the registration
                    process on the basis of your consent (Art. 6 Sect. 1 lit. a
                    GDPR).
                </p>{' '}
                <p>
                    The data recorded during the registration process shall be
                    stored by us as long as you are registered on this website.
                    Subsequently, such data shall be deleted. This shall be
                    without prejudice to mandatory statutory retention
                    obligations.
                </p>
                <h3>YouTube</h3>
                <p>1. Scope of processing of personal data</p>
                <p>
                    We use the plugin operated by Google from YouTube, YouTube
                    LLC, 901 Cherry Ave, San Bruno, CA 94066, USA and their
                    representatives in the Union Google Ireland Limited, Gordon
                    House, Barrow Street, Dublin 4, Ireland (Hereinafter
                    referred to as Google). We use the plugin from YouTube to
                    embed videos from YouTube on our online presence. When you
                    visit our website, your browser connects to YouTube's
                    servers. It may be used to store and analyse personal data,
                    in particular user activity (in particular which pages have
                    been visited and which elements have been clicked on) and
                    device and browser information (in particular IP address and
                    operating system).
                    <br />
                    We have no influence on the content of the plug-in. If you
                    are logged into your YouTube account during your visit,
                    YouTube can assign your online presence visit to this
                    account. By interacting with this plug-in, this
                    corresponding information is transmitted directly to YouTube
                    and stored there. \Further information on the collection and
                    storage of data by Google can be found here:
                    <br />
                    <a
                        href="https://policies.google.com/privacy?hl=en-GB"
                        target="_blank"
                        rel="noopener">
                        https://policies.google.com/privacy?hl=en-GB
                    </a>
                </p>
                <p>2. Purpose of data processing</p>
                <p>
                    The use of the YouTube PlugIn serves the improvement of the
                    user friendliness and an appealing representation of our
                    on-line operational readiness level.
                </p>
                <p>3. Legal basis for the processing of personal data</p>
                <p>
                    The legal basis for the processing of personal data is the
                    user's given consent in accordance with Art. 6 (1) (1) (a)
                    GDPR.
                </p>
                <p>4. Duration of storage</p>
                <p>
                    Your personal information will be stored for as long as is
                    necessary to fulfill the purposes described in this Privacy
                    Policy or as required by law, e.g. for tax and accounting
                    purposes.
                </p>
                <p>5. Possibility of revocation of consent and removal</p>
                <p>
                    You have the right to revoke your declaration of consent
                    under data protection law at any time. The revocation of the
                    consent does not affect the lawfulness of the processing
                    carried out on the basis of the consent up to the
                    revocation.
                    <br />
                    You can prevent the collection and processing of your
                    personal data by Google by preventing the storage of cookies
                    from third parties on your computer, by using the "Do Not
                    Track" function of a supporting browser, by deactivating the
                    execution of script code in your browser or by using a
                    script blocker such as a browser browser browser.B. Install
                    NoScript (
                    <a
                        href="https://noscript.net/"
                        target="_blank"
                        rel="noopener">
                        https://noscript.net/
                    </a>
                    ) or Ghostery (
                    <a href="https://www.ghostery.com">www.ghostery.com</a>) in
                    your browser.
                    <br />
                    With the following link you can deactivate the use of your
                    personal data by Google:
                    <br />
                    <a
                        href="https://adssettings.google.com"
                        target="_blank"
                        rel="noopener">
                        https://adssettings.google.com
                    </a>
                    <br />
                    Further information on objection and removal options against
                    Google can be found at:
                    <br />
                    <a
                        href="https://policies.google.com/privacy?hl=en-GB"
                        target="_blank"
                        rel="noopener">
                        nhttps://policies.google.com/privacy?hl=en-GB
                    </a>
                </p>
                <h2>4. Plug-ins and Tools</h2>
                <h3>Google Web Fonts</h3>{' '}
                <p>
                    To ensure that fonts used on this website are uniform, this
                    website uses so-called Web Fonts provided by Google. When
                    you access a page on our website, your browser will load the
                    required web fonts into your browser cache to correctly
                    display text and fonts.
                </p>{' '}
                <p>
                    To do this, the browser you use will have to establish a
                    connection with Google’s servers. As a result, Google will
                    learn that your IP address was used to access this website.
                    The use of Google Web Fonts is based on Art. 6 Sect. 1 lit.
                    f GDPR. The website operator has a legitimate interest in a
                    uniform presentation of the font on the operator’s website.
                    If a respective declaration of consent has been obtained
                    (e.g. consent to the archiving of cookies), the data will be
                    processed exclusively on the basis of Art. 6 Sect. 1 lit. a
                    GDPR. Any such consent may be revoked at any time.
                </p>{' '}
                <p>
                    If your browser should not support Web Fonts, a standard
                    font installed on your computer will be used.
                </p>{' '}
                <p>
                    For more information on Google Web Fonts, please follow this
                    link:{' '}
                    <a
                        href="https://developers.google.com/fonts/faq"
                        target="_blank"
                        rel="noopener noreferrer">
                        https://developers.google.com/fonts/faq
                    </a>{' '}
                    and consult Google’s Data Privacy Declaration under:{' '}
                    <a
                        href="https://policies.google.com/privacy?hl=en"
                        target="_blank"
                        rel="noopener noreferrer">
                        https://policies.google.com/privacy?hl=en
                    </a>
                    .
                </p>
            </div>
            <div className={classes.buttonContainer}>
                <Button reverted onClick={previousStep}>
                    {locale.userManagement.stepBack}
                </Button>
                <Button onClick={acceptTs}>{locale.common.acceptTerms}</Button>
            </div>
        </React.Fragment>
    )
}
/* eslint-enable */
